import React from "react";

export default function PdcDashboard() {
  return <div>PdcDashboard</div>;
}
